/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceWithNewDataPlan { 
    deviceId?: number;
    newDataPlan?: DeviceWithNewDataPlan.NewDataPlanEnum;
}
export namespace DeviceWithNewDataPlan {
    export const NewDataPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type NewDataPlanEnum = typeof NewDataPlanEnum[keyof typeof NewDataPlanEnum];
}


export type NewDataPlanEnum = typeof DeviceWithNewDataPlan.NewDataPlanEnum[keyof typeof DeviceWithNewDataPlan.NewDataPlanEnum];
